export default "__VITE_ASSET__BGpgt7Gn__"